import html2canvas from "html2canvas";

/**
 * Captura um elemento da DOM e salva como PNG.
 * @param {string} elementId - ID do elemento que será capturado.
 * @param {string} filename - Nome do arquivo.
 * @param {string} captureUntilId - ID do último elemento que deve aparecer na captura.
 * @param {{ scale?: number }} options - Opções de qualidade da imagem.
 */
export async function captureElementToImage(
  elementId,
  filename = "screenshot.png",
  captureUntilId,
  { scale = 2 } = {}
) {
  const el = document.getElementById(elementId);
  if (!el) return false;

  const captureUntil = captureUntilId ? document.getElementById(captureUntilId) : null;
  const captureHeight = captureUntil
    ? Math.ceil(captureUntil.getBoundingClientRect().bottom - el.getBoundingClientRect().top)
    : el.scrollHeight;

  try {
    // 🔥 garante fontes carregadas
    await document.fonts.ready;

    // Permite que o toast seja renderizado antes da operação pesada de captura.
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

    const canvas = await html2canvas(el, {
      scale,
      useCORS: true,
      logging: false,
      width: el.scrollWidth,
      height: captureHeight,
      onclone: (clonedDocument) => {
        clonedDocument.getElementById(elementId)?.querySelectorAll("*").forEach((element) => {
          element.style.overflow = "visible";
        });
      },
    });

    const imageBlob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
    if (!imageBlob) return false;

    const link = document.createElement("a");
    const imageUrl = URL.createObjectURL(imageBlob);
    link.href = imageUrl;
    link.download = filename;
    link.click();
    setTimeout(() => URL.revokeObjectURL(imageUrl), 0);

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}
